import { useState } from 'react'
import { query } from '@cbgms/components/list'
import { ShopStatus } from '@cbgms/api/modules/index'
import { ShopListRow } from '../components/List'

export type StatusQueryTypes = 'all' | ShopStatus

export const useShopQueryByStatus = () => {
  const [statusType, setStatusType] = useState<StatusQueryTypes>(ShopStatus.Active)

  const apiSearchQuery =
    statusType === 'all'
      ? ''
      : query<ShopListRow>()
          .equals(o => o.Shop.Status, statusType)
          .toString()

  return { statusType, setStatusType, apiSearchQuery }
}
